/**
 * Determines which search key to use based on activeFilters
 * Checks for 'name.regexp' first, then 'name.list', defaults to 'name.regexp'
 *
 * @param activeFilters - The active filters object
 * @returns The key to use for search operations
 */
export const getSearchKeyToUse = (
  activeFilters: Record<string, any> | undefined,
): string => {
  if (activeFilters?.['name.regexp'] !== undefined) {
    return 'name.regexp';
  }

  if (activeFilters?.['name.list'] !== undefined) {
    return 'name.list';
  }

  return 'name.regexp';
};
